<template>
    <div class="page--header">
        <h2>{{ title }}</h2>
        <div v-if="icon">
            <div class="form-group" :class="{'form-active': showSearch}" v-if="type ==='search'">
                <input
                    @key="search"
                    @keyup="search"
                    v-model="query"
                    type="text"
                    id="search"
                    :class="{'show-search': showSearch , 'hide-search': !showSearch}"
                    :placeholder="$translate.text('general.search')"
                />
                <i :class="[{'white': showSearch}, `${icon}`]" @click="iconClicked"></i>
            </div>

        </div>
    </div>
</template>
<script>

import debounce from 'lodash/debounce';

export default {
    name: 'PageHeader',

    props: {
        title: {
            type: String,
            required: true,
        },

        icon: {
            type: String,
            default: null,
        },

        type: {
            type: String,
            default: 'search',
        },
    },

    data() {
        return {
            showSearch: false,
            query: '',
        };
    },

    methods: {
        iconClicked() {
            if (this.type === 'search') {
                this.showSearch = !this.showSearch;

                // if the value is false after changing reset the search
                if (!this.showSearch) {
                    this.query = '';
                    this.search();
                }
            }
        },

        // eslint-disable-next-line
        search: debounce(function(event) {
            // Need to use Eslint disable because i need the This event for the emit.
            // otherwise we need an arrow function that doesnt support the this for the emit
            this.$emit('catchEmit', this.query);
        }, 500),
    },
};
</script>
<style lang="scss" scoped>
/* Styles are found in _page.scss */
.form-group {
    display: flex;
    align-items: center;
    border: 0;
    border-radius: 4px;
    padding: 8px 16px;
    width: 70px;
    transition: background-color 500ms linear, width 500ms linear;

    label {
        color: $black;
        flex: 2;
    }

    input {
        flex: 6;
        font-size: 16px;
        background: transparent;
        border: none;
        color: white;

        &::placeholder {
            color: white;
            opacity: 0.7;
        }
    }

    input:focus {
        outline: 0;
    }

}

.form-active {
    width:400px;
    background-color: $blue-light;
    transition: background-color 500ms linear, width 500ms linear;
}

.show-search {
    visibility: visible;
    width: 400px;
    transition: width 1000ms linear;
    opacity: 1;
}

.hide-search {
    opacity: 0;
    width: 0px;
    visibility: hidden;
}

.white {
    color: white !important;
}

</style>
